// Contents
import React, { useEffect, useState, useMemo } from 'react';
import PageHero from "../pageHero/PageHero_Home.jsx";
import ProjectsSwiper from "../pages/swiper/ProjectsSwiper.jsx";
import About from "../pages/home/About.jsx";
import Contact from "../pages/home/Contact.jsx";
import { supabase } from '../../utils/supabase.js';

export default function Home({ navigate, lowPerfContent, lang })
{
    const [textRows, setTextRows] = useState(null);
    const [projectRows, setProjectRows] = useState(null);
    const [translationRows, setTranslationRows] = useState(null);

    useEffect(() => {
        Promise.all([
            supabase.from('home_content').select('key, fr, en'),
            supabase.from('projects').select('id, slug, image_swiper, swiper_show, agency').order('position'),
            supabase.from('projects_translations').select('project_id, lang, title, agency'),
        ]).then(([textRes, projRes, transRes]) => {
            if (textRes.data) setTextRows(textRes.data);
            if (projRes.data) setProjectRows(projRes.data);
            if (transRes.data) setTranslationRows(transRes.data);
        });
    }, []);

    const textMap = useMemo(() => {
        if (!textRows) return null;
        const map = {};
        textRows.forEach(r => { map[r.key] = { fr: r.fr, en: r.en }; });
        return map;
    }, [textRows]);

    const allProjects = useMemo(() => {
        if (!projectRows || !translationRows) return null;
        return projectRows.map(p => {
            const trans = translationRows.find(t => t.project_id === p.id && t.lang === lang);
            return {
                ...p,
                imageSwiper: p.image_swiper,
                swiperShow: p.swiper_show,
                title: trans?.title ?? '',
                agency: trans?.agency ?? p.agency,
            };
        });
    }, [projectRows, translationRows, lang]);

    return (<>
        <PageHero navigate={navigate} lowPerfContent={lowPerfContent} />

        <About navigate={navigate} lang={lang} textMap={textMap} />

        <ProjectsSwiper navigate={navigate} lang={lang} textMap={textMap} allProjects={allProjects} />

        <Contact navigate={navigate} lang={lang} textMap={textMap} />
    </>);
}
